export const tabsListMaidianConfig: any = {
    aStock: 'agu',
    hkStock: 'gg',
    newStock: 'xsb'
}
